export default "__VITE_ASSET__CsCWm9J7__"